import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectPrefabHeading } from '../_redux-scene';
import { PrefabHeading } from '@gift/basic-scene-core/BasicSceneOptions';
import { Prefab } from '@gift/basic-scene-core/Prefab';
import { AppDispatch, WebsiteState } from '@gift/website-state/store';
import { PrefabPickerAccordion } from './partials/PrefabPickerAccordion';
import { PrefabPickerModal } from './partials/PrefabPickerModal';
import { Translate } from '@gift/types/generic/Translate';
import { applyPrefab, selectFilteredPrefabs } from '@gift/basic-scene-website/_redux-prefabs';

export const _PrefabPicker = ({ prefabs, apply, heading }: Props) => {

    const { t } = useTranslation();
    const [selectedPrefab, setSelectedPrefab] = useState(prefabs[0]);

    const translations: { [Key in PrefabHeading]: string } = {
        'layouts': t('prefab.heading.layouts'),
        'designs': t('prefab.heading.designs')
    };

    const commit = (prefab: Prefab) => {
        setSelectedPrefab(prefab);
        apply(prefab, t);
    };

    return (
        <>
            <PrefabPickerAccordion
                title={translations[heading]}
                prefabs={prefabs} selectedPrefab={selectedPrefab}
                commit={commit} />
            <PrefabPickerModal
                title={translations[heading]}
                prefabs={prefabs} selectedPrefab={selectedPrefab}
                commit={commit} />
        </>
    );
};

type Props = {
    prefabs: Prefab[],
    apply: (p: Prefab, t: Translate) => void,
    heading: PrefabHeading,
};

const mapStateToProps = (state: WebsiteState) => ({
    prefabs: selectFilteredPrefabs(state),
    heading: selectPrefabHeading(state)
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    apply: (p: Prefab, t: Translate) => dispatch(applyPrefab(p, t))
});

export const PrefabPicker = connect(
    mapStateToProps,
    mapDispatchToProps
)(_PrefabPicker);
